import './Core.css';
import { styled } from 'styled-components';
import HomeSlide from './components/slides/HomeSlide';
import SectionHeader from './components/widgets/SectionHeader';
import { globalStore } from './AppManager';
import ContactSlide from './components/slides/ContactSlide';
import GetExperienceList from './data/experience-list';
import TopNav from './components/navigation/TopNav';
import ServicesSlide from './components/slides/ServicesSlide';
import AboutSlide from './components/slides/AboutSlide';
import GallerySlide from './components/slides/GallerySlide';
import ContactSlide2 from './components/slides/ContactSlide';
import MobileNav from './components/navigation/MobileNav';
import FooterSlide from './components/slides/FooterSlide';
import ReviewsSlide from './components/slides/ReviewsSlide';

const Container = styled.div.attrs({ className: "app" })`
  width: 100%;
  display: flex;
  overflow: hidden;
  background: var(--black);
  box-sizing: border-box;

  #app-content {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100dvh;
    flex-shrink: 0;
    transition: 0.3s;
    box-sizing: border-box;
    overflow-y: auto;
  }
`

function App() {

  const { visible, setVisible } = globalStore((state) => state.navigation);

  return (
    <Container menuIsVisible={visible}>

      <TopNav />
      <MobileNav />

      <div id='app-content' onClick={() => setVisible(false)}>

        <HomeSlide />
        <AboutSlide />
        <ServicesSlide />
        <ReviewsSlide />
        <GallerySlide />
        <ContactSlide />
        <FooterSlide />

      </div>

    </Container>
  );
}

export default App;
